import localEn from './en'
import localVi from './vi'
import sharedEN from './shared/en'
import sharedVI from './shared/vi'

export default {
  en: {
    ...sharedEN,
    ...localEn
  },
  vi: {
    ...sharedVI,
    ...localVi
  }
}
